import { HomeView } from "./views/home-view";
import { ResourceAssignmentView } from "./views/resource-assignment-view";
import { ProjectManagementView } from "./views/project-management-view";
import { ResourceFinderView } from "./views/resource-finder-view";
import { DemandView } from "./views/demand-view";
import { HelpView } from "./views/help-view";
import { globalApp } from "./app"
import { fireBaseLog } from "./common";
import { DemandDetailView } from "./views/demand-detail-view";
import { ResourceDetailView } from "./views/resource-detail-view";
import { DemandCopyView } from "./views/demand-copy-view";

customElements.define('home-view', HomeView);
customElements.define("demand-detail-view", DemandDetailView);
customElements.define('demand-view', DemandView);
customElements.define('project-management-view', ProjectManagementView);
customElements.define('help-view', HelpView);
customElements.define('employee-detail-view', ResourceDetailView);
customElements.define('employee-assignment-view', ResourceAssignmentView);
customElements.define('resource-finder-view', ResourceFinderView);
customElements.define("demand-copy-view", DemandCopyView);


export class Navigation {


    static nav: { [key: string]: any } = {
        "/": HomeView,
        "/resource-assignment": ResourceAssignmentView,
        "/project-management": ProjectManagementView,
        "/resource-finder": ResourceFinderView,
        "/demands": DemandView,
        "/help": HelpView
    };
    static nav_default = "/";

    /**
     * Handle hash navigation
     */
    static hashNav() {
        if (location.hash == "") {
            location.hash = "#" + this.nav_default;
            return;
        }

        $(".nav-link").each(function () {
            const href = $(this).attr("href");
            if (href && location.hash.startsWith(href)) {
                $(".nav-link").removeClass("active");
                $(this).addClass("active");
            }
        });

        var hash = location.hash.split("#")[1];
        var page = hash.split("?")[0];
        var mainpage = "/" + page.split("/")[1];
        var subpage = page.split("/")[2];
        var params = hash.split("?")[1];

        if (Navigation.nav[mainpage]) {
            $(".loader").show();
            globalApp.context.params = {};
            if (params) globalApp.context.params = Navigation.parseRouteParamsString(params);
            globalApp.context.params.subpage = subpage;
            if (mainpage === "/") {
                globalApp.context.view = new HomeView(globalApp.context, ".main");
            } else {
                globalApp.context.view = new Navigation.nav[mainpage](globalApp.context, ".main");
            }

            const mainSection = document.querySelector(".main");
            if (mainSection) {
                mainSection.innerHTML = "";
                if (globalApp.context.view) {
                    mainSection.appendChild(globalApp.context.view);
                }
            }
            globalApp.context.history.push(location.hash);

            fireBaseLog("page_view", { page_title: document.title });
        } else {
            location.hash = Navigation.nav_default;
        }
    }

    /**
     * Navigate to a page with optional parameters
     * @param {string} page
     * @param {object} params
     * @param {boolean} justUpdate
     * @returns {void}
     */
    static navigateHash(page: string | null, params: any, justUpdate = false) {
        const url = Navigation.buildNavigationUrl(page, params);
        if (justUpdate) {
            history.pushState(null, '', url);
            globalApp.context.history.push(url);
        } else {
            location.href = url;
        }
    }

    static buildNavigationUrl(page: string | null, params: any) {
        var hash = location.hash.split("#")[1];
        if (!page) page = hash.split("?")[0];
        const hashUrl = "#" + page;

        var strParams = Navigation.buildRouteParamsString(params);
        return hashUrl + "?" + strParams;
    }

    static buildRouteParamsString(params: any) {
        const urlparams = new URLSearchParams();

        for (var key in params) {
            if (key === "subpage") continue;
            if (typeof params[key] === "object") {
                urlparams.append(key, JSON.stringify(params[key]));
            } else {
                urlparams.append(key, params[key]);
            }
        }
        const strParams = urlparams.toString();
        return strParams;
    }

    static parseRouteParamsString(paramString: string) {
        const urlparams = new URLSearchParams(paramString);
        const params: { [key: string]: any } = {};
        for (var key of urlparams.keys()) {
            const val = urlparams.get(key);
            try {
                params[key] = val ? JSON.parse(val) : null;
            } catch (err) {
                params[key] = val;
            }
        }
        return params;
    }

    static restorePreviousHashUrl() {
        if (globalApp.context.history.length > 1) {
            globalApp.context.history.pop();
            history.pushState(null, '', globalApp.context.history[globalApp.context.history.length - 1]);
        }
    }
}


